import {Forms} from "./Content/Form"
const forms = new Forms;

setTimeout(() => {
    forms.init();
}, 250)





